// src/components/common/Pagination.js
import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  siblingCount = 1,
}) => {
  const range = (start, end) =>
    Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const getPaginationRange = () => {
    const totalPageNumbers = siblingCount * 2 + 5;
    if (totalPages <= totalPageNumbers) return range(1, totalPages);

    const leftSibling = Math.max(currentPage - siblingCount, 1);
    const rightSibling = Math.min(currentPage + siblingCount, totalPages);
    const showLeftDots = leftSibling > 2;
    const showRightDots = rightSibling < totalPages - 1;

    if (!showLeftDots && showRightDots) {
      return [...range(1, 3 + 2 * siblingCount), "...", totalPages];
    }

    if (showLeftDots && !showRightDots) {
      return [
        1,
        "...",
        ...range(totalPages - (2 + 2 * siblingCount), totalPages),
      ];
    }

    if (showLeftDots && showRightDots) {
      return [1, "...", ...range(leftSibling, rightSibling), "...", totalPages];
    }
  };

  const paginationRange = getPaginationRange();

  return (
    <div className="flex items-center justify-center mt-10 gap-2 flex-wrap">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="rounded-full px-4 py-2 text-sm font-semibold text-stone-700 bg-white border border-stone-200 shadow-sm hover:bg-stone-50 disabled:opacity-40 disabled:pointer-events-none"
      >
        Prev
      </button>

      {paginationRange.map((page, idx) =>
        page === "..." ? (
          <span key={idx} className="px-2 py-1 text-stone-400">
            ...
          </span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`min-w-[2.5rem] rounded-full px-3 py-2 text-sm font-semibold transition ${
              page === currentPage
                ? "bg-rose-600 text-white shadow-md"
                : "bg-white text-stone-700 border border-stone-200 hover:bg-stone-50"
            }`}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="rounded-full px-4 py-2 text-sm font-semibold text-stone-700 bg-white border border-stone-200 shadow-sm hover:bg-stone-50 disabled:opacity-40 disabled:pointer-events-none"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
